import React, { useCallback, useMemo } from 'react'
import { Switch as SwitchAnt } from 'antd'
import Form, { FormItemProps } from 'antd/lib/form'
import dp from 'dot-prop-immutable'
import { useT } from 'src/core/hooks/use-translation'
import { SwitchProps } from 'antd/lib/switch'

type Props = SwitchProps &
  Pick<FormItemProps, 'label' | 'required' | 'hasFeedback'> & {
    formikProps: any
    iconInfo?: JSX.Element
    name: string
  }

export default function Switch({
  formikProps,
  hasFeedback = false,
  iconInfo,
  label,
  name,
  onChange,
  required,
  title,
  ...props
}: Props) {
  const { t } = useT()
  const error = useMemo(() => {
    return dp.get(formikProps.errors, name)
  }, [formikProps.errors, name])
  const handleChange = useCallback(
    (value: boolean) => {
      formikProps.setFieldValue(name, value)
      if (onChange) {
        onChange(value, undefined)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [formikProps.setFieldValue, name]
  )
  const touched = useMemo(() => {
    return dp.get(formikProps.touched, name)
  }, [formikProps.touched, name])
  const value = useMemo(() => {
    return dp.get(formikProps.values, name)
  }, [formikProps.values, name])

  let iconLabel = t(label)
  if (iconInfo) {
    iconLabel = (
      <>
        {iconLabel}
        {iconInfo}
      </>
    )
  }
  return (
    <Form.Item
      colon={false}
      hasFeedback={hasFeedback}
      help={touched && typeof error === 'string' ? t(error) : ''}
      label={iconLabel}
      required={required}
      validateStatus={
        error && touched ? 'error' : !error && touched ? 'success' : ''
      }
    >
      <SwitchAnt {...props} defaultChecked={value} onChange={handleChange} />
    </Form.Item>
  )
}
